export default __webpack_public_path__ + "images/a49abc28fa1d6a41278bcf347eaaff81.svg";